/**
 * The Measure and Coordinates tools own map clicks while they are active.
 *
 * The field-selection step also listens for clicks, on the `polygon-fill` layer,
 * and Mapbox offers no way to cancel a layer handler from a map-level one — both
 * fire for the same click. Without a shared signal, dropping a measure point on
 * top of a field would silently re-pick the trial's field.
 *
 * The map tools panel raises this flag while a click-driven tool runs; map
 * interactions that must not react to tool clicks check it first.
 */
let toolCapturingClicks = false;

export const setMapToolCapturingClicks = (capturing: boolean): void => {
  toolCapturingClicks = capturing;
};

export const isMapToolCapturingClicks = (): boolean => toolCapturingClicks;
